import React from "react";
import { ProgressBar, ProgressContainer, ProgressFill, Step, StepsContainer, StepWrapper, StyledContainer } from "./progress-bar.styles";

const allSteps = [
  "Contract details",
  "Payment method",
  "Upload documents",
  "Done",
];

const ProgressSteps: React.FC<{ currentStep: number; stripeEligible?: boolean }> = ({ currentStep, stripeEligible = true }) => {
  const steps = stripeEligible
    ? allSteps
    : allSteps.filter(s => s !== "Payment method");

  // Map the internal step number to the visible step index
  const stepMap = stripeEligible
    ? { 0: 0, 1: 1, 2: 2, 3: 3 }
    : { 0: 0, 2: 1, 3: 2 }; // skip step 1 (payment method)
  const adjustedStep = (stepMap as any)[currentStep] ?? 0;
  const progress = (adjustedStep / (steps.length - 1)) * 100;

  return (
    <StyledContainer>
      <ProgressContainer>
        <ProgressBar>
          <ProgressFill progress={progress} />
        </ProgressBar>
        <StepsContainer>
          {steps.map((step, index) => (
            <StepWrapper key={index}>
              <Step
                active={index <= adjustedStep}>
                {step}
              </Step>
            </StepWrapper>
          ))}
        </StepsContainer>
      </ProgressContainer>
    </StyledContainer>
  );
};

export default ProgressSteps;
